import React from 'react';

// Ambient decoration: a small flowering vine that grows along the header,
// reflecting the user's current daily reading streak. No pressure mechanics —
// a lapsed streak just quietly prunes the vine back, no messaging of any kind.
// Streak value is read from the existing brew-streak system (BookContext's
// `streakCount`, itself sourced from `profiles.brew_streak`, computed by the
// `update_brew_streak_on_checkin` DB trigger on `brew_history` inserts) rather
// than recomputed here.
const MAX_SEGMENTS = 10; // vine caps out visually around a 10+ day streak

const ReadingVine = ({ streak = 0 }) => {
  const segments = Math.max(0, Math.min(MAX_SEGMENTS, streak));

  if (segments === 0) {
    return null; // no streak yet (or lapsed) — nothing rendered, no copy at all
  }

  const leaves = Array.from({ length: segments });

  return (
    <div
      aria-hidden="true"
      title={`${streak} day reading streak`}
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: '6px',
        overflow: 'visible',
        pointerEvents: 'none',
        zIndex: 1
      }}
    >
      <svg
        width="100%"
        height="28"
        style={{ position: 'absolute', bottom: '-4px', left: 0, overflow: 'visible' }}
        preserveAspectRatio="none"
      >
        <path
          d={`M 8 4 ${leaves.map((_, i) => {
            const x = 8 + i * 22;
            const y = i % 2 === 0 ? 8 : 2;
            return `Q ${x + 11} ${y - 6}, ${x + 22} ${y}`;
          }).join(' ')}`}
          fill="none"
          stroke="var(--vine-stem, #7a9b6e)"
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity="0.55"
        />
        {leaves.map((_, i) => {
          const x = 8 + i * 22 + 11;
          const y = i % 2 === 0 ? 2 : 8;
          const bloom = i >= segments - 3; // last few segments get a flower, not just leaf
          return (
            <g key={i} transform={`translate(${x}, ${y})`} opacity="0.75">
              <ellipse
                rx="4"
                ry="2.5"
                fill="var(--vine-leaf, #8fb586)"
                transform={i % 2 === 0 ? 'rotate(-20)' : 'rotate(20)'}
              />
              {bloom && (
                <circle r="2" cy="-2" fill="var(--vine-bloom, #e8a5c4)" />
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default ReadingVine;
